module.exports = __webpack_public_path__ + "img/selectedBg.ba23c390.svg";